const isEmptyBase = val => val === null || val === '' || !Object.keys(val).length;
const isNil = x => x == null;

const isEmpty = variable => isNil(variable) || isEmptyBase(variable);

export default isEmpty;
